import * as React from 'react';

import moment from 'moment';

import { Button } from '@coursera/coursera-ui';

import RpcActionType from 'bundles/widget-simulator/components/tools/log/RpcActionType';
import type { Action, ActionErrors } from 'bundles/widget-simulator/types';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/RpcAction';

const INTERVAL_DELAY = 5 * 1000; // 5 seconds

const styles = {
  button: {
    padding: '10px 0',
    width: '100%',
  },
};

const ErrorsIndicator = ({ errors }: { errors: ActionErrors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return <div className="rc-ErrorsIndicator">*</div>;
};

type Props = {
  action: Action;
  onClick: (action: Action) => void;
};

type State = {
  tickTime: number;
};

class RpcAction extends React.Component<Props, State> {
  state = {
    tickTime: 0,
  };

  componentDidMount() {
    this.intervalId = window.setInterval(this.tick, INTERVAL_DELAY);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  handleClick = () => {
    const { action, onClick } = this.props;
    onClick(action);
  };

  intervalId = 0;

  tick = () => {
    // Periodically refresh the component so the moment().fromNow() displays will change.
    this.setState({ tickTime: Date.now() });
  };

  render() {
    const { action } = this.props;
    const { tickTime } = this.state;
    const time = moment(action.time);
    // This is always going to choose Date.now(), but I had to do this to make the linter
    // stop complaining about tickTime being unused. tickTime is not rendered, but it
    // is necessary to force a refresh as time goes on without resorting to this.forceUpdate().
    const now = moment(Math.max(Date.now(), tickTime));

    if (action.name === 'DIVIDER') {
      return <div className="rc-RpcActionDivider">{_t('Plugin Reloaded')}</div>;
    }

    return (
      <div className="rc-RpcAction">
        <Button isThemeDark={false} type="noStyle" style={styles.button} onClick={this.handleClick}>
          <div className="button-content-container horizontal-box">
            <RpcActionType type={action.type} />
            <div className="action-name flex-1 horizontal-box">
              <span>{action.name}</span>
              <ErrorsIndicator errors={action.errors} />
            </div>
            <abbr className="action-time" title={time.format()}>
              {time.from(now)}
            </abbr>
          </div>
        </Button>
      </div>
    );
  }
}

export default RpcAction;
